import React, { memo, RefObject } from 'react';

import { Box, SxProps } from '@mui/material';

import { TabSymbol } from '@/features/Dashboard/context/EditChartApp';

import { SortableItem } from './SortableItem';

type DroppableAreaProps = {
  id: string;
  items: TabSymbol[];
  sx?: SxProps;
  baseIndex?: number;
  container: RefObject<HTMLDivElement | null>;
};

const DroppableAreaComponent: React.FC<DroppableAreaProps> = ({
  id,
  items,
  sx = {},
  baseIndex = 0,
  container
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 100,
        ...sx
      }}
    >
      {items.map((item, index) => (
        <SortableItem
          key={item.id}
          container={container}
          item={item}
          itemIndex={index + baseIndex}
          sourceListId={id}
        />
      ))}
    </Box>
  );
};

export const DroppableArea = memo(DroppableAreaComponent);
